import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { ICompanyParams, ICompanyResponse, ICompanyState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchCreateCompany = createAsyncThunk(
  'listCompanies/fetchCreateCompany',
  async (params: ICompanyParams, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.createCompany(params)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: ICompanyState = {
  isLoading: false,
  response: null,
  error: null
}

const createCompanySlice = createSlice({
  name: 'states/show',
  initialState,
  reducers: {
    resetCreateCompany: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchCreateCompany.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchCreateCompany.fulfilled, (state, action: PayloadAction<ICompanyResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchCreateCompany.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default createCompanySlice.reducer
export const { resetCreateCompany } = createCompanySlice.actions
